import React, { useEffect, useState } from "react";
import { Button, Col, Input, Row, Space, Modal, Radio } from "antd";
import DashboardShape from "../../../Assets/Images/doctor.png";
import AddIcon from "../../../Assets/Images/Svg/add.svg";
import InviteIcon from "../../../Assets/Images/Svg/inviteicon.svg";
import { useForm } from "antd/es/form/Form";
import DoctorService from "../../../Services/DoctorService";
import person from "../../../Assets/Icons/person.svg";
import NewPatientInvite from "../Dashboard/NewPatientInvite";
import ExistingPatient from "../Dashboard/ExistingPatient";
import Invitelink from "../../../Assets/Images/Invitelink.svg";
import Invite from "../../../Assets/Images/Invite.svg";

function NewInviteCard({ appointmentsList }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [accountDetails, setAccountDetails] = useState({});

  const [paymentType, setPaymentType] = useState("Cash"); //changed
  const [paymentReceived, setPaymentReceived] = useState(true); //changed
  const [form, setForm] = useForm();
  const [callType, setCallType] = useState("APPT_VIDEO");

  const [quickInvite, setQuickInvite] = useState(false);
  const [disableRequired, setDisableRequired] = useState(true);

  const [mobileNumber, setMobileNumber] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [radioValue, setRadioValue] = useState("newPatient");

  const storedLoginResult = localStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  const onChange = (e) => {
    setQuickInvite(false);
    setRadioValue(e.target.value);
    form.resetFields();
    setIsVisible(false);
    setMobileNumber("");
    setPaymentType("Cash"); // temporarily put it in commented because they want by default select will be Cash
    setCallType("APPT_VIDEO");
  };

  const handleKeyPress = (e) => {
    const allowedKeys = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
    ];

    if (e.ctrlKey || e.metaKey) return;

    if (!allowedKeys.includes(e.key)) {
      e.preventDefault();
    }

    if (!isNaN(e.key) && e.target.value.length >= 10) {
      e.preventDefault();
    }
  };

  useEffect(() => {
    appointmentsList();
    getAccountDetails();
  }, []);

  const getAccountDetails = async () => {
    DoctorService.getHospitalAccountData(loginResultObject.user.account_Id)
      .then((res) => {
        setAccountDetails(res.data[0]);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const showModal = () => setIsModalOpen(true);

  const handleOk = () => {
    form.resetFields();
    setIsModalOpen(false);
    setMobileNumber("");
    appointmentsList();
    setPaymentType("Cash"); // temporarily changed because they want by default select will be Cash
    setQuickInvite(false);
    setPaymentReceived(true); // temporarily changed because they want by default Checked
    setDisableRequired(true);
    setRadioValue("newPatient");
    setCallType("APPT_VIDEO");
  };

  const handleCancel = () => {
    form.resetFields();
    setPaymentType("Cash"); // temporarily changed because they want by default select will be Cash
    setMobileNumber("");
    setIsModalOpen(false);
    setIsVisible(false);
    setRadioValue("newPatient");
    setQuickInvite(false);
    setPaymentReceived(true); // temporarily changed because they want by default Checked
    setDisableRequired(true);
    setCallType("APPT_VIDEO");
  };


  return (
    <>
      <div
        className="bg-white rounded-md w-[304px] h-[46px] flex items-center cursor-pointer justify-center text-center gap-2"
        onClick={showModal}
      >
        <img src={person} alt="" className="w-6 h-6" />
        <p className="mt-4 font-sans font-medium text-sm text-[#333333]">
          Invite a patient for a consultation
        </p>
      </div>

      <Modal
        title={
          <div className="flex items-center  border-brand-colorBorder pb-4">
            {" "}
            {/* <img src={InviteIcon} alt="img" /> */}
            <h3 className="mb-0 text-sm font-semibold tracking-wider ml-3">
              Invite a patient for a consultation
            </h3>
          </div>
        }
        footer={[]}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width="50%"
        height="10%"
        style={{
          top: 20,
          width: "100%", // Default width as a base
          maxWidth: "100%",
        }}
      >
        <div className="border">
          <div className="bg-[#F6FEFF] h-28 p-3 border-b">
            <div className="flex justify-between items-center">
              <div>
                <div className="flex  gap-2">
                  <img src={Invitelink} alt="img" className="w-6 h-6" />
                  <span>Invite Link</span>
                </div>
                <div className="mt-4">
                  <Radio.Group
                    onChange={onChange}
                    value={radioValue}
                    className="custom-radio"
                  >
                    <Radio value={"newPatient"}>Quick Invite</Radio>
                    <Radio value={"existingPatient"}>Existing Patient</Radio>
                    {/* <Radio value={"domainPatient"}>Domain Patient</Radio> */}
                  </Radio.Group>
                </div>
              </div>
              <img src={Invite} alt="img" className="w-32 h-20" />
            </div>
          </div>
          {radioValue === "newPatient" ? (
            <NewPatientInvite
              form={form}
              handleOk={handleOk}
              handleKeyPress={handleKeyPress}
              appointmentsList={appointmentsList}
              paymentType={paymentType}
              setPaymentType={setPaymentType}
              paymentReceived={paymentReceived}
              setPaymentReceived={setPaymentReceived}
              callType={callType}
              setCallType={setCallType}
              //
              quickInvite={quickInvite}
              setQuickInvite={setQuickInvite}
              disableRequired={disableRequired}
              setDisableRequired={setDisableRequired}
              accountDetails={accountDetails}
            />
          ) : (
            <ExistingPatient
              form={form}
              handleOk={handleOk}
              handleKeyPress={handleKeyPress}
              appointmentsList={appointmentsList}
              paymentType={paymentType}
              setPaymentType={setPaymentType}
              paymentReceived={paymentReceived}
              setPaymentReceived={setPaymentReceived}
              callType={callType}
              setCallType={setCallType}
              //
              setMobileNumber={setMobileNumber}
              mobileNumber={mobileNumber}
              radioValue={radioValue}
              isVisible={isVisible}
              setIsVisible={setIsVisible}
            />
          )}
        </div>
      </Modal>
    </>
  );
}

export default NewInviteCard;
